import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Variants';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "variants"
    }}>{`Variants`}</h1>
    <p>{`All Rebass components accept a `}<inlineCode parentName="p">{`variant`}</inlineCode>{` prop, which allows you to define stylistic variations in your theme and apply the styles on a per-element basis.`}</p>
    <p>{`For example, with the following defined in the theme object:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme with variants
export default {
  colors: {
    text: 'black',
    background: 'white',
    primary: 'tomato',
  },
  shadows: {
    card: '0 0 4px rgba(0, 0, 0, 0.125)',
  },
  variants: {
    card: {
      p: 2,
      bg: 'background',
      boxShadow: 'card',
      borderRadius: 2,
    },
    badge: {
      display: 'inline-block',
      p: 1,
      color: 'white',
      bg: 'primary',
      borderRadius: 2,
    }
  },
}
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`Box`}</inlineCode>{` component can use a variant style to render with preset card or badge styles.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Box variant='card' width={256}>
  Card
  <Box variant='badge'>
    Badge
  </Box>
</Box>
`}</code></pre>
    <p>{`By default, Rebass components will use style objects defined in `}<inlineCode parentName="p">{`theme.variants`}</inlineCode>{`.
The `}<inlineCode parentName="p">{`Text`}</inlineCode>{` and `}<inlineCode parentName="p">{`Heading`}</inlineCode>{` components use a custom `}<inlineCode parentName="p">{`theme.text`}</inlineCode>{` object, and `}<inlineCode parentName="p">{`Button`}</inlineCode>{` uses `}<inlineCode parentName="p">{`theme.buttons`}</inlineCode>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Theme Key`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Variant`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Box`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variants`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Flex`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variants`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Heading`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`heading`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Link`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variants`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`link`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Button`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`buttons`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`primary`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Image`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variants`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Card`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variants`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`card`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`Any object in your theme can be used as a variant, and the values use dot notation for deeply nested values.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// example variant with dot notation
<Box variant='some.deeply.nested.object' />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      